import { isPartnershipEligible } from '@shared/partnershipEligibility';
import { FundingPolicyType } from '@shared';
import { cn } from '@/lib';

interface PartnershipEligibleBadgeProps {
  policyType: number;
  state: string;
  primaryAge: number;
  bioPercent: string | number | null;
  isCompoundInflation?: boolean;
  className?: string;
}

export function PartnershipEligibleBadge({
  policyType,
  state,
  primaryAge,
  bioPercent,
  isCompoundInflation,
  className,
}: PartnershipEligibleBadgeProps) {
  if (policyType !== FundingPolicyType.careScoutCareAssurance) {
    return null;
  }

  const eligible = isPartnershipEligible({
    state,
    ageAtIssue: primaryAge,
    bioPercent,
    policyType,
    isCompoundInflation,
  });

  if (!eligible) {
    return null;
  }

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center justify-center rounded-full border px-3 py-1 text-xs font-medium',
        'border-purple-200 bg-purple-50 text-purple-700',
        className,
      )}
      data-testid="partnership-eligible-badge"
    >
      Partnership Eligible<sup>**</sup>
    </span>
  );
}
